import client from '../../client'

export interface Params {
  code?: string
  code2?: string
}

export interface Response {
  form: {
    user: {
      [key: string /* フォームの名前 e.g. 'kana1' */]: string | null
    }
  }
  master: {
    grade: { label: string; value: number }[]
    highSchNpp: { label: string; value: number }[]
    hopeArea: { label: string; value: number }[]
    hopeCourse: { label: string; value: number }[]
    hopeDepart: {
      [key: number /* hopeCourseのID e.g. 1 */]: { label: string; value: number }[]
    }
    prefecture: { label: string; value: number }[]
    sex: { label: string; value: number }[]
  }
}

export async function get(params?: Params) {
  return client.get<Response>('get_request_appli_data', { params }).then(({ data }) => data)
}
